import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Calendários da Rede',
    path: '/calendario/calendariorede',
    name: 'calcalendariorede',
    component: () => import('@/views/calendario/calcalendario/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.CALENDARIOREDEDEENSINONOVO_MENU_200100199],
    },
    goesToMenu: true,
  },
  {
    description: 'Calendários da Escola',
    path: '/calendario/calendarioescola',
    name: 'calcalendario',
    component: () => import('@/views/calendario/calcalendario/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.CALENDARIOUNIDADEESCOLARNOVO_MENU_200100299],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Calendário',
    path: '/calendario/calendario/cadastro/:id?',
    parent: 'calcalendario',
    name: 'calcalendario_create',
    component: () => import('@/views/calendario/calcalendario/components/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.CALENDARIOREDEDEENSINONOVO_MENU_200100199, eTipoPermissao.CALENDARIOUNIDADEESCOLARNOVO_MENU_200100299],
    },
    goesToMenu: true,
  },
  {
    description: 'Visualização de Calendário',
    path: '/calendario/calendario/visualizar/:id',
    parent: 'calcalendario',
    name: 'calcalendario_visualizar',
    component: () => import('@/views/calendario/calcalendario/components/CalendarioIndex.vue'),
    meta: {
      permissions: [eTipoPermissao.CALENDARIOREDEDEENSINONOVO_MENU_200100199, eTipoPermissao.CALENDARIOUNIDADEESCOLARNOVO_MENU_200100299],
    },
    goesToMenu: true,
  },
];
